// src/hooks/useAddProductConfig.js

import { useState } from "react";

// Paletas y estilos para chips de etiquetas (mismo look que CreateTaskModal)
export const pastelColors = ["#FBE6FC", "#D9F4F8", "#FFECE1", "#E1F6FF", "#E9FBEF"];
export const tagTextColors = ["#C31388", "#1F7190", "#D24A00", "#234E99", "#147A52"];

export const tagStyles = {
  pastelColors,
  tagTextColors, 
  tagsBox: {
    width: "100%",
    boxSizing: "border-box",
    minHeight: 44,
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
    padding: "6px 8px",
    borderRadius: "10px",
    border: "1px solid #E5E7EB",
    background: "#F8FAFB",
    margin: "6px 0 12px",
  },
  tagChip: (i) => ({
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    height: 28,
    padding: "0 10px",
    borderRadius: 4,
    fontSize: 12,
    fontWeight: 700,
    backgroundColor: pastelColors[i % pastelColors.length],
    color: tagTextColors[i % tagTextColors.length],
    boxShadow: "0 2px 4px rgba(0,0,0,.04)",
  }),
  tagClose: { cursor: "pointer", opacity: 0.7 },
  tagInput: {
    flex: 1,
    minWidth: 120,
    height: 28,
    border: "none",
    outline: "none",
    background: "transparent",
    padding: "0 6px",
  },
};

// src/hooks/useAddProductConfig.js
export const customStyles = {
  content: {
    top: 0,                 // ← antes: "64px"
    right: 0,
    bottom: 0,
    left: "60px",           // si quieres también quitar el margen izquierdo, pon 0
    border: "none",
    borderRadius: 0,
    padding: "12px 32px 24px", // un poco de aire interno arriba
    background: "#FFF",
    overflow: "auto",
    direction: "ltr",
    unicodeBidi: "plaintext",
    fontFamily: "Inter, sans-serif",
  },
  overlay: {
    backgroundColor: "rgba(0,0,0,0.5)",
    zIndex: 1000,
  },
};

export const variantInputStyle = {
    width: 223,
    height: 35,
    padding: "4px 8px",
    borderRadius: 4,
    border: "1px solid #E6EDFF",
    background: "#FAFAFB",
    fontSize: 14,
    boxSizing: "border-box",
};

export const sectionTitleStyle = {
    margin: "0 0 8px 0",
    fontSize: 18,
    fontWeight: 600,
    color: "#333",
};

export  const fieldsetStyle = {
    border: "1px solid #E6EDFF",
    borderRadius: 8,
    padding: 24,
    marginBottom: 24,
};

export const unidadesSAT = [
    { clave: "H87", nombre: "Pieza" },
    { clave: "E48", nombre: "Unidad de servicio" },
    { clave: "EA", nombre: "Elemento" },
    { clave: "KGM", nombre: "Kilogramo" },
    { clave: "MTR", nombre: "Metro" },
    { clave: "ACT", nombre: "Actividad" },
    { clave: "E51", nombre: "Trabajo" },
    { clave: "A9", nombre: "Tarifa" },
    { clave: "KT", nombre: "Kit" },
    { clave: "LTR", nombre: "Litro" },
    { clave: "XBX", nombre: "Caja" },
    { clave: "HUR", nombre: "Hora" },
    { clave: "11", nombre: "Equipos" },
    { clave: "SET", nombre: "Conjunto" },
    { clave: "AB", nombre: "Paquete a granel" },
    { clave: "E54", nombre: "Viaje" },
    { clave: "DAY", nombre: "Día" },
    { clave: "DPC", nombre: "Docenas de piezas" },
];

export  const generalFields = [
    { label: "Modelo", name: "modelo", placeholder: "Introduce Modelo" },
    { label: "Número de Parte", name: "numeroDeParteProveedor", placeholder: "Introduce el Número de Parte" },
    { label: "Categoría", name: "categoria", isSelect: true, options: ["SNEAKERS","ACCESORIOS"], placeholder: "Seleccionar categoría" },
    { label: "Marca", name: "marca", placeholder: "Introduce la Marca" },
];

export const priceFields = [
    { label: <span style={{ color: "red" }}>Precio*</span>, name: "costo", type: "number", placeholder: "Precio"},
    { label: "Impuesto", name: "impuesto", isSelect: true, options: ["IVA 16%","IEPS"], placeholder: "Seleccionar" },
    { label: "Existencias", name: "existencias", type: "number", placeholder: "Stock Inicial" },
];

export const defaultTypeHistory = ["Porcentaje", "Fijo"];

// Estado inicial de producto
export const DEFAULT_PRODUCT = {
  nombre: "",
  modelo: "",
  numeroDeParteProveedor: "",
  categoria: "",
  marca: "",
  descripcion: "",
  especificaciones: "",
  notas: "",
  unidadSAT: "",
  claveSAT: "",
  costo: "",
  impuesto: "",
  existencias: "",
  descuento: "",
  tipoDescuento: "",
  almacen: "",
  etiquetas: [],
  imagen: null,
};

// Hook para historial de descuentos
export function useDiscountConfig(product, setProduct) {
  const [discountHistory, setDiscountHistory] = useState([]);
  const [typeHistory, setTypeHistory] = useState(defaultTypeHistory);

  const handleDiscountChange = e => {
    const v = e.target.value;
    setProduct(pr => ({ ...pr, descuento: v }));
    if (v && !discountHistory.includes(v)) {
      setDiscountHistory(prev => [...prev, v]);
    }
  };

  const handleTipoChange = e => {
    const v = e.target.value;
    setProduct(pr => ({ ...pr, tipoDescuento: v }));
    if (v && !typeHistory.includes(v)) {
      setTypeHistory(prev => [...prev, v]);
    }
  };

  const discountFields = [
    {
      label: "Descuento",
      name: "descuento",
      placeholder: "Seleccionar descuento",
      options: discountHistory.map(d => ({ value: d, label: d })),
      onChange: handleDiscountChange,
      value: product.descuento,
    },
    {
      label: "Tipo de Descuento",
      name: "tipoDescuento",
      placeholder: "Seleccionar tipo",
      options: typeHistory.map(t => ({ value: t, label: t })),
      onChange: handleTipoChange,
      value: product.tipoDescuento,
    },
  ];

  return { discountFields };
}
